module.exports = __webpack_public_path__ + "static/media/location.e238dec4.svg";